'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RafNavItem = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _multitrack = require('helpers/multitrack');

var _actions = require('components/CallToAction/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RafNavItem = exports.RafNavItem = function (_Component) {
  (0, _inherits3.default)(RafNavItem, _Component);

  function RafNavItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RafNavItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RafNavItem.__proto__ || (0, _getPrototypeOf2.default)(RafNavItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      (0, _multitrack.ga)('Refer-a-Friend', 'raf-nav-click');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RafNavItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          reward = _props.reward,
          user = _props.user;


      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          _actions.ShowFriendbuyWidget,
          {
            onClick: this.handleClick,
            user: user
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'header.link.raf',
            defaultMessage: 'Get {reward}',
            values: { reward: reward }
          })
        )
      );
    }
  }]);
  return RafNavItem;
}(_react.Component);

RafNavItem.propTypes = {
  reward: _propTypes2.default.string.isRequired,
  user: _propTypes2.default.object.isRequired
};